import { usePaymentsWetag, PaymentsOrg } from '@wetags/payments';

export const useCareCreditLocationStatus = (locationId: string | undefined) => {
  const { useWetag } = usePaymentsWetag({ locationId });
  const [isCareCreditEnabled, isCareCreditLoading] = useWetag('care-credit-enabled', {});
  const { isEnabled: isCareCreditOrgEnabled } = PaymentsOrg.useWetagQuery('care-credit-enabled');

  return {
    isCareCreditOrgEnabled,
    isCareCreditEnabled: isCareCreditEnabled || isCareCreditOrgEnabled || false,
    isCareCreditLoading,
  };
};
